var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{class:_vm.className,attrs:{"title":_vm.title,"width":_vm.width,"visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event},"closed":_vm.closed}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }